import * as _ from 'lodash';
import { Action } from "redux";

import { ActionTypes } from "../actions/actionTypes";
import { ConceptFeedback } from '../interfaces/conceptsFeedback';

type FillInBlankConceptsFeedbackAction = Action & { cid: string, data: ConceptFeedback[] }

export interface FillInBlankConceptsFeedbackState {
  data: {[key:string]: ConceptFeedback};
  hasreceiveddata: boolean;
  newConceptModalOpen: boolean;
  states: {[key: string]: string};
  submittingnew: boolean;
}

const initialState = {
  fillInBlankConceptsFeedback: {
    data: {},
    hasreceiveddata: false,
    newConceptModalOpen: false,
    states: {}, // this will store per quote id if we're reading, editing or awaiting DB response
    submittingnew: false,
    translated_data: null
  }
}

export default function(currentstate: FillInBlankConceptsFeedbackState, action: FillInBlankConceptsFeedbackAction) {
  let newstate;
  switch (action.type) {
    case ActionTypes.RECEIVE_FITB_CONCEPTS_FEEDBACK_DATA:
      return Object.assign({}, currentstate, {
        data: action.data,
        hasreceiveddata: true,
      });
    case ActionTypes.RECEIVE_TRANSLATED_FITB_CONCEPTS_FEEDBACK_DATA:
      return Object.assign({}, currentstate, {
        translated_data: action.data
      });
    case ActionTypes.AWAIT_NEW_FITB_CONCEPTS_FEEDBACK_RESPONSE:
      return Object.assign({}, currentstate, {
        submittingnew: true
      });
    case ActionTypes.RECEIVE_NEW_FITB_CONCEPTS_FEEDBACK_RESPONSE:
      return Object.assign({}, currentstate, {
        newConceptModalOpen: false,
        submittingnew: false,
      });
    case ActionTypes.START_FITB_CONCEPTS_FEEDBACK_EDIT:
      newstate = _.cloneDeep(currentstate);
      newstate.states[action.cid] = ActionTypes.START_FITB_CONCEPTS_FEEDBACK_EDIT;
      return newstate;
    case ActionTypes.FINISH_FITB_CONCEPTS_FEEDBACK_EDIT:
      newstate = _.cloneDeep(currentstate);
      delete newstate.states[action.cid];
      return newstate;
    case ActionTypes.SUBMIT_FITB_CONCEPTS_FEEDBACK_EDIT:
      newstate = _.cloneDeep(currentstate);
      newstate.states[action.cid] = ActionTypes.SUBMITTING_FITB_CONCEPTS_FEEDBACK;
      return newstate;
    default: return currentstate || initialState.fillInBlankConceptsFeedback;
  }
};
